import { PageLayout } from '@retail/components';
import { Alert, Box, Paper, Stack, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { FeatureTogglesTable } from './FeatureTogglesTable';
import { TagHeading } from '@shared/components';

export function FeatureTogglesPage() {
  const t = useAppTFunction();
  return (
    <PageLayout maxWidth="full" fixedHeight>
      <Paper
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        <Stack spacing={2} alignItems="flex-start">
          <Stack px={3} pt={3} flexDirection="row" alignItems="center" gap={2} whiteSpace="nowrap">
            <TagHeading color="success">
              <Typography variant="h4" component="h1">
                {t('app.routes.features')}
              </Typography>
            </TagHeading>
            <Alert severity="warning">This page is only visible to super users</Alert>
          </Stack>
          <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
            <FeatureTogglesTable />
          </Box>
        </Stack>
      </Paper>
    </PageLayout>
  );
}
